import styles from './RequestToJoinOrganisation.module.scss'
import { Text, ButtonText } from '@percent/lemonade'
import { useTranslation } from 'react-i18next'
import { RequestToJoinOrganisationProps } from './RequestToJoinOrganisation.types'
import { useNavigate } from 'react-router-dom'
import { RoutePath } from '@percent/cause-dashboard/app/routes/Routes'

export function RequestToJoinOrganisation({
  organisationId,
  organisationName
}: Readonly<RequestToJoinOrganisationProps>) {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div className={styles.requestToJoinContainer} data-testid="request-to-join-organisation-view">
      <div className={styles.requestToJoinTextWrapper}>
        <Text size="small">{t('form.requestToJoinDescription')}</Text>
      </div>
      <ButtonText
        variant="primary"
        onClick={() => navigate(`${RoutePath.REQUEST_TO_JOIN}?id=${organisationId}&name=${organisationName}`)}
        data-testid="request-to-join-button"
      >
        {t('button.requestToJoin.title')}
      </ButtonText>
    </div>
  )
}
